import classNames from 'classnames';
import { useEffect, useState } from 'react';

interface Props {
  size?: number;
  gap?: number;
  speed?: number;
  bgColor?: string;
  cyTag?: string;
}

export const LoadingSpinner = ({
  cyTag,
  bgColor = 'bg-white',
  size = 30,
  gap = 0,
  speed = 300,
}: Props) => {
  const [styleIndices, setStyleIndices] = useState([0, 1, 2, 3]);
  const baseClasses = 'transition-all duration-300 ease-in-out';
  const styles = [
    `${baseClasses} bg-primary-300`,
    `${baseClasses} bg-primary-300`,
    `${baseClasses} bg-primary-50`,
    `${baseClasses} ${bgColor}`,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setStyleIndices((prev) => {
        const newIndices = [...prev];
        const last = newIndices.pop() as number;
        newIndices.unshift(last);
        return newIndices;
      });
    }, speed);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      data-cy={cyTag}
      role="status"
      aria-label="Loading"
      className="flex h-full justify-center items-center"
    >
      <div style={{ width: `${size * 2 + gap}px`, height: `${size * 2 + gap}px` }}>
        <div className="flex" style={{ gap: `${gap}px`, marginBottom: `${gap}px` }}>
          <span
            className={classNames(styles[styleIndices[0]])}
            style={{ width: `${size}px`, height: `${size}px` }}
          />
          <span
            className={classNames(styles[styleIndices[1]])}
            style={{ width: `${size}px`, height: `${size}px` }}
          />
        </div>
        <div className="flex flex-row-reverse" style={{ gap: `${gap}px` }}>
          <span
            className={classNames(styles[styleIndices[2]])}
            style={{ width: `${size}px`, height: `${size}px` }}
          />
          <span
            className={classNames(styles[styleIndices[3]])}
            style={{ width: `${size}px`, height: `${size}px` }}
          />
        </div>
      </div>
    </div>
  );
};
